/** Intervalo padrão de datas para busca de logs (dd/mm/aaaa). */

export function formatDateBR(date) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

/**
 * @param {number} [daysBack=30]
 * @param {Date} [now]
 */
export function defaultLogDateRange(daysBack = 30, now = new Date()) {
  const to = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const from = new Date(to);
  from.setDate(from.getDate() - daysBack);
  return {
    from: formatDateBR(from),
    to: formatDateBR(to),
  };
}
